"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Products = void 0;
var _analyticsData = require("@ori/analytics-data");
var _featureToggles = require("@ori/feature-toggles");
var _productBox = require("@ori/product-box");
var _productList = require("@ori/product-list");
var _react = require("react");
var _constants = require("../../constants");
var _contexts = require("../../contexts");
var _jsxRuntime = require("react/jsx-runtime");
const Products = ()=>{
    const { isFeatureEnabled } = (0, _featureToggles.useFeatureToggles)();
    const { productBoxConfiguration, products } = (0, _contexts.useDetailContext)();
    const renderItemComponent = (0, _react.useCallback)((param)=>{
        let { item: product, index } = param;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_productBox.ProductBox, {
            ...product,
            analyticsData: {
                placement: _analyticsData.Placement.PersonalProductList,
                position: index
            },
            hideRating: !productBoxConfiguration.isRatingsAndReviewsEnabled,
            hideSubscription: !isFeatureEnabled(_constants.PersonalProductListFeature.PersonalSubscriptions),
            mrpStatementEnabled: productBoxConfiguration.isMrpStatementEnabled,
            withTranslationsProvider: false
        }, product.code);
    }, [
        isFeatureEnabled,
        productBoxConfiguration.isMrpStatementEnabled,
        productBoxConfiguration.isRatingsAndReviewsEnabled
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_productList.ProductList, {
        items: products,
        shouldRenderItemCount: false,
        withTranslationsProvider: false,
        renderItemComponent: renderItemComponent
    });
};
exports.Products = Products;
